import { addSeconds } from "date-fns";
import { useDeviceLang } from "hooks/deviceHooks";
import { useViewerQuery } from "queries/viewerQuery";
import React from "react";
import { Trans } from "react-i18next";
import styled from "styled-components/macro";

const Wrap = styled.div`
  color: ${({ theme }) => theme.duo.color.green};
  font-size: 13px;
  font-weight: bold;
  margin: 0 4px 23px;
`;

const SubscribedUntil: React.FC = () => {
  const {
    viewer,
    subscriptionFlags: { isSubscriptionCancelled }
  } = useViewerQuery();
  const { appLang } = useDeviceLang();

  if (!viewer?.subscription) return null;

  return (
    <Wrap>
      {isSubscriptionCancelled ? (
        <Trans>Subscription is cancelled and will expire on</Trans>
      ) : (
        <Trans>Subscribed until</Trans>
      )}
      :{" "}
      {addSeconds(new Date(), viewer?.subscription?.timeToExpire).toLocaleDateString(appLang, {
        year: "numeric",
        month: "long",
        day: "numeric"
      })}
    </Wrap>
  );
};

export default SubscribedUntil;
